import { ArrowRight } from "lucide-react";

const HeroSection = () => {
  return (
    <section className="relative bg-hero-bg overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto section-padding pt-28 pb-16 md:pt-36 md:pb-20">
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-hero-foreground leading-[1.08] tracking-tight mb-6 reveal-up-delay-1">
            Grow Your Dental Practice With Marketing That Works
          </h1>
          <p className="text-lg md:text-xl text-hero-foreground/60 max-w-2xl mx-auto mb-8 leading-relaxed reveal-up-delay-2">
            Nearly two decades of strategy, execution, and results for dentists who want more patients, more revenue, and less guesswork.
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 reveal-up-delay-3">
            <a
              href="https://www.xpresspromotion.com/contact"
              className="inline-flex items-center justify-center gap-2 bg-accent text-accent-foreground px-8 py-4 rounded-lg text-base font-semibold hover:bg-accent/90 transition-all duration-200 active:scale-[0.97] shadow-lg shadow-accent/25"
            >
              Book a Strategy Call
              <ArrowRight className="w-4 h-4" />
            </a>
            <a
              href="https://www.xpresspromotion.com/about"
              className="inline-flex items-center justify-center gap-2 border border-hero-foreground/20 text-hero-foreground px-8 py-4 rounded-lg text-base font-medium hover:bg-hero-foreground/5 transition-all duration-200 active:scale-[0.97]"
            >
              Learn About Us
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
